export class Calendar2 {
  constructor(http) {
    this.http = http;
  }

  fetchCalendar(type, dateType, startDate, endDate, teamLead) {
    if (startDate && endDate) {
      startDate = startDate.valueOf();
      endDate = endDate.valueOf();
    }

    return this.http
      .get(`calendar/${type}/`, { params: { dateType, startDate, endDate, teamLead } })
      .then(response => normalizeCalendar2(response.data));
  }

  fetchCalendarExpandable(type, dateType, startDate, endDate, userId, teamLead) {
    if (startDate && endDate) {
      startDate = startDate.valueOf();
      endDate = endDate.valueOf();
    }
    return this.http
      .get(`calendar/${type}/expandable/`, { params: { dateType, startDate, endDate, userId, teamLead } })
      .then(response => normalizeCalendar2(response.data));
  }
}


function normalizeCalendar2(response) {
  return { users: Object.keys(response.users), data: response.users, tHeader: response.t_header };
}
